import { render, staticRenderFns } from "./pedestrian.vue?vue&type=template&id=72897118&scoped=true"
import script from "./pedestrian.vue?vue&type=script&lang=js"
export * from "./pedestrian.vue?vue&type=script&lang=js"
import style0 from "./pedestrian.vue?vue&type=style&index=0&id=72897118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72897118",
  null
  
)

export default component.exports